<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Product Sales Report") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                      ✖
                    </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="GetProductSaleReport('N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="finalBoxOfficeSalesData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- s -->
        <a
          target="_blank"
          @click="GetProductSaleReport('Y')"
          title="Download as PDF"
          download
        >
          <img
            class="mx-1"
            src="@/assets/img/icons/pdf.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="finalBoxOfficeSalesData.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th rowspan="2"></th>
                <th colspan="">Gross Price</th>
                <th colspan="">Net Price</th>
                <th colspan="">Sales Quantity</th>
                <th colspan="">Total Gross</th>
                <th colspan="">Total Net</th>
                <th colspan="">% Group</th>
                <th colspan="">% Category</th>
                <th colspan="">% Total</th>
              </tr>
            </thead>
            <template
           v-for= "(rateCardData, boxOfficeIndes) in finalBoxOfficeSalesData"
            >
              <tr  class="distName">
                <th class="text-left" colspan="10">
                  {{rateCardData.cinema_id}} {{rateCardData.rc_g_name}} 
                </th>
              </tr>
              <template 
              v-for= "(boxOfficeData, boxOfficeIndes) in rateCardData.data">
                <tr >
                  <td class="text-left">
                    {{boxOfficeData.seat_type_name}}
                  </td>

                  <td class="text-right">
                    {{currFormat(boxOfficeData.per_unit_gross_price)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(boxOfficeData.per_unit_net_price)}}
                  </td>
                  <td class="text-right">
                     {{boxOfficeData.quantity}}
                  </td>
                  <td class="text-right">
                     {{currFormat(boxOfficeData.gross_amount)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(boxOfficeData.net_amount)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(boxOfficeData.groupPercent)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(boxOfficeData.categoryPercent)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(boxOfficeData.totalPercent)}}
                  </td>        
                </tr>
              </template >

              <tr>
                <td colspan="3" class="text-left font-weight-bold">Total</td>
                <td class="text-right font-weight-bold">
                  {{rateCardData.fc_category_total.quantity}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(rateCardData.fc_category_total.gross_amount)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(rateCardData.fc_category_total.net_amount)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(rateCardData.fc_category_total.percentageGroup)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(rateCardData.fc_category_total.percentageCategory)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(rateCardData.fc_category_total.percentageTotal)}}
                </td>
              
              </tr>
            </template>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="3">Total Box Office</th>
                
                <th class="text-right"> {{boxOfficeTotal.quantity}}</th>
                <th class="text-right">
                  {{currFormat(boxOfficeTotal.gross_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(boxOfficeTotal.net_amount)}}
                </th>
                <th class="text-right">
                  -
                </th>
                <th class="text-right">
                  {{currFormat(boxOfficeTotal.percentageCategory)}}
                </th>
                <th class="text-right">
                  {{currFormat(boxOfficeTotal.percentagetotal)}}
                </th>
               
              </tr>
            </thead>
          </table>
        </div>

        <!-- Other Fees and Other data -->
        <div style="margin-top: 40px;">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="finalBoxOfficeSalesData.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th rowspan="2"></th>
                <th colspan="">Gross Price</th>
                <th colspan="">Net Price</th>
                <th colspan="">Sales Quantity</th>
                <th colspan="">Total Gross</th>
                <th colspan="">Total Net</th>
                <th colspan="">% Group</th>
                <th colspan="">% Category</th>
                <th colspan="">% Total</th>
              </tr>
            </thead>
            <template>
              <tr>
                <td colspan="9" class="text-left font-weight-bold">Other</td>
              </tr>
              <tr>
                <td colspan="9" class="text-left font-weight-bold">Comps</td>
              </tr>
              <tr v-for ="(ticketOtherData, ticketotherDataindex) in ticketOtherData ">
                <td class="text-left">{{ticketOtherData.offer_name}}</td>
                <td class="text-right">{{currFormat(ticketOtherData.gross_amount)}}</td>
                <td class="text-right">{{currFormat(ticketOtherData.net_amount)}}</td>
                <td class="text-right">{{ticketOtherData.quantity}}</td>
                <td class="text-right">{{currFormat(ticketOtherData.gross_amount)}}</td>
                <td class="text-right">{{currFormat(ticketOtherData.net_amount)}}</td>
                <td class="text-right">{{currFormat(ticketOtherData.groupPercent)}}</td>
                <td class="text-right">{{currFormat(ticketOtherData.categoryPercent)}}</td>
                <td class="text-right">{{currFormat(ticketOtherData.totalPercent)}}</td>
              </tr>
            </template>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="3">Total Comps</th>
                
                <th class="text-right"> {{grandTotalOther.quantity}}</th>
                <th class="text-right">
                  {{currFormat(grandTotalOther.gross_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOther.net_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOther.perecentageGroup)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOther.percentageCategory)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOther.percentageCategory)}}
                </th>
              </tr>
            </thead>

            <template>
              <tr>
                <td colspan="9" class="text-left font-weight-bold">Other Fees</td>
              </tr>   
              <tr v-for ="(ticketOtherFeesData, ticketotherDataindex) in ticketOtherFeesData ">
                <td class="text-left">{{ticketOtherFeesData.experience_fee}}</td>
                <td class="text-right">{{currFormat(ticketOtherFeesData.gross_amount)}}</td>
                <td class="text-right">{{currFormat(ticketOtherFeesData.net_amount)}}</td>
                <td class="text-right">{{ticketOtherFeesData.quantity}}</td>
                <td class="text-right">{{currFormat(ticketOtherFeesData.gross_amount)}}</td>
                <td class="text-right">{{currFormat(ticketOtherFeesData.net_amount)}}</td>
                <td class="text-right">{{currFormat(ticketOtherFeesData.groupPercent)}}</td>
                <td class="text-right">{{currFormat(ticketOtherFeesData.categoryPercent)}}</td>
                <td class="text-right">{{currFormat(ticketOtherFeesData.totalPercent)}}</td>
              </tr>
            </template>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="3">Total Other Fees</th>
                
                <th class="text-right"> {{grandTotalOtherFees.quantity}}</th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.gross_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.net_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.perecentageGroup)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.percentageCategory)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.percentageCategory)}}
                </th>
              </tr>
            </thead>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="3">Total Others</th>
                
                <th class="text-right"> {{grandTotalOtherFees.quantity + grandTotalOther.quantity}}</th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.gross_amount + grandTotalOther.gross_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.net_amount + grandTotalOther.net_amount)}}
                </th>
                <th class="text-right">
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.percentageCategory + grandTotalOther.percentageCategory)}}
                </th>
                <th class="text-right">
                  {{currFormat(grandTotalOtherFees.percentageCategory + grandTotalOther.percentageCategory)}}
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <!-- Concession Data -->
        <div style="margin-top: 40px;">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="finalBoxOfficeSalesData.length > 0"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th rowspan="2"></th>
                <th colspan="">Gross Price</th>
                <th colspan="">Net Price</th>
                <th colspan="">Sales Quantity</th>
                <th colspan="">Total Gross</th>
                <th colspan="">Total Net</th>
                <th colspan="">% Group</th>
                <th colspan="">% Category</th>
                <th colspan="">% Total</th>
              </tr>
            </thead>
            <template
           v-for= "(categoryNameData, boxOfficeIndes) in finalProductSalesData"
            >
              <tr  class="distName">
                <th class="text-left" colspan="10">
                 {{categoryNameData.fc_category}}
                </th>
              </tr>
              <template 
              v-for= "(categoryData, boxOfficeIndes) in categoryNameData.data">
                <tr >
                  <td class="text-left">
                    {{categoryData.fst_item_name}}
                  </td>

                  <td class="text-right">
                    {{currFormat(categoryData.per_unit_gross_price)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(categoryData.per_unit_net_price)}}
                  </td>
                  <td class="text-right">
                     {{categoryData.quantity}}
                  </td>
                  <td class="text-right">
                     {{currFormat(categoryData.gross_amount)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(categoryData.net_amount)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(categoryData.groupPercent)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(categoryData.categoryPercent)}}
                  </td>
                  <td class="text-right">
                     {{currFormat(categoryData.totalPercent)}}
                  </td>        
                </tr>
              </template >

              <tr>
                <td colspan="3" class="text-left font-weight-bold">Total</td>
                
                <td class="text-right font-weight-bold">
                  {{categoryNameData.fc_category_total.quantity}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(categoryNameData.fc_category_total.gross_amount)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(categoryNameData.fc_category_total.net_amount)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(categoryNameData.fc_category_total.percentageGroup)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(categoryNameData.fc_category_total.percentageCategory)}}
                </td>
                <td class="text-right font-weight-bold">
                  {{currFormat(categoryNameData.fc_category_total.percentageTotal)}}
                </td>
              
              </tr>
            </template>
            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="3">Total Concession</th>
                
                <th class="text-right"> {{fnbTotal.quantity}}</th>
                <th class="text-right">
                  {{currFormat(fnbTotal.gross_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(fnbTotal.net_amount)}}
                </th>
                <th class="text-right">
                  -
                </th>
                <th class="text-right">
                  {{currFormat(fnbTotal.percentageCategory)}}
                </th>
                <th class="text-right">
                  {{currFormat(fnbTotal.percentagetotal)}}
                </th>
               
              </tr>
            </thead>

            <thead class="bg-lightgrey">
              <tr>
                <th class="text-left" colspan="3">Grand Total</th>
                
                <th class="text-right"> {{fnbTotal.quantity + grandTotalOtherFees.quantity + boxOfficeTotal.quantity + grandTotalOther.quantity}}</th>
                <th class="text-right">
                  {{currFormat(fnbTotal.gross_amount + grandTotalOtherFees.gross_amount + boxOfficeTotal.gross_amount + grandTotalOther.gross_amount)}}
                </th>
                <th class="text-right">
                  {{currFormat(fnbTotal.net_amount + grandTotalOtherFees.net_amount + boxOfficeTotal.net_amount + grandTotalOther.net_amount)}}
                </th>
                <th class="text-right">
                  -
                </th>
                <th class="text-right">
                  -
                </th>
                <th class="text-right">
                  {{currFormat(fnbTotal.percentagetotal + grandTotalOther.percentagetotal +
                  grandTotalOtherFees.percentagetotal + boxOfficeTotal.percentagetotal
                  )}}
                </th>
               
              </tr>
            </thead>
          </table>
        </div>
      </div>

      <table
        v-if="Object.keys(productSalesData).length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead class="bg-lightgrey">
          <tr>
            <th rowspan="2"></th>
                <th colspan="">Gross Price</th>
                <th colspan="">Net Price</th>
                <th colspan="">Sales Quantity</th>
                <th colspan="">Total Gross</th>
                <th colspan="">Total Net</th>
                <th colspan="">% Group</th>
                <th colspan="">% Category</th>
                <th colspan="">% Total</th>
              </tr>
      
        </thead>
        <tbody>
          <tr>
            <td colspan="14">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
  
  <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      productSalesData: {},
      boxOfficeTotal: {},
      fnbTotal : {},
      grandTotalOther : {},
      grandTotalOtherFees : {},
      finalBoxOfficeSalesData : [],
      finalProductSalesData : [],
      ticketOtherData: [],
      ticketOtherFeesData : [],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
  },
  watch: {},
  mounted() {},
  methods: {
    onChangeDate: function (e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    GetProductSaleReport(isPdf = "N") {
      this.productSalesData = {};
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
      };
      ReportsService.GetProductSaleReport(payload)
        .then((response) => {
          const { data } = response;
          
          if (data.status && Object.keys(data.Records).length) {
            this.productSalesData = data.Records;
            this.finalBoxOfficeSalesData = this.productSalesData.finalBoxOfficeSalesData
            this.boxOfficeTotal = data.grandTotalBoxOffcie

            this.finalProductSalesData = this.productSalesData.finalProductSalesData
            this.fnbTotal = data.grandTotalFnb

            this.ticketOtherData = this.productSalesData.ticketOtherData
            this.grandTotalOther = data.grandTotalOther

            this.ticketOtherFeesData = this.productSalesData.ticketOtherFeesData
            this.grandTotalOtherFees = data.grandTotalOtherFees
          //  console.log("finalBoxOfficeSalesData", this.finalBoxOfficeSalesData)


            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>
  
  <style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/productSaleReport.vue